/** Innerer Anzeigeradius um die Filiale auf der Karte. */
export const BRANCH_INNER_RADIUS_KM = 20;

/** Freigrenze Luftlinie zur Filiale – darüber Fernzuschlag. */
export const BRANCH_FREE_RADIUS_KM = 40;

/** Zuschlag pro angefangene 10 km über der Freigrenze. */
export const DISTANCE_SURCHARGE_BLOCK_KM = 10;
export const DISTANCE_SURCHARGE_PER_BLOCK_EUR = 12.36;

export function haversineKm(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180;
  const earthRadius = 6371000;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return (earthRadius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))) / 1000;
}

export function calculateDistanceSurchargeEur(distanceKm: number | null | undefined): number {
  if (distanceKm == null || !Number.isFinite(distanceKm) || distanceKm <= BRANCH_FREE_RADIUS_KM) {
    return 0;
  }
  const excessKm = distanceKm - BRANCH_FREE_RADIUS_KM;
  const startedBlocks = Math.ceil(excessKm / DISTANCE_SURCHARGE_BLOCK_KM);
  return Math.round(startedBlocks * DISTANCE_SURCHARGE_PER_BLOCK_EUR * 100) / 100;
}

export function calculateStopBaseKosten(stop: {
  lieferkostenEK?: number | null;
  montagekostenEK?: number | null;
}): number {
  return (stop.lieferkostenEK ?? 0) + (stop.montagekostenEK ?? 0);
}

export function calculateStopTotalKosten(
  stop: { lieferkostenEK?: number | null; montagekostenEK?: number | null },
  distanceKm: number | null | undefined
): number {
  return calculateStopBaseKosten(stop) + calculateDistanceSurchargeEur(distanceKm);
}

export function getStopDistanceKmFromBranch(
  stop: { lat: number | null; lng: number | null; geocodingFailed?: boolean },
  branch: { lat: number; lng: number } | null
): number | null {
  if (!branch || stop.lat == null || stop.lng == null || stop.geocodingFailed) {
    return null;
  }
  const lat = Number(stop.lat);
  const lng = Number(stop.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }
  return haversineKm(branch.lat, branch.lng, lat, lng);
}
